var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.auth.loggedIn && (_vm.$store.state.auth.user.role === 'admin' || _vm.$store.state.auth.user.role === 'editor' || _vm.$store.state.auth.user.role === 'limited_editor'))?_c('AdminEventList'):_c('EventList')
}
var staticRenderFns = []

export { render, staticRenderFns }